import { Link } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';

/** Usuário autenticado, mas ainda sem clínica vinculada (claims não emitidas). */
export function SemVinculoPage() {
  const { usuario, sair, recarregarClaims } = useAuth();
  return (
    <div className="tela-status">
      <div className="cartao">
        <h1>Conta sem clínica vinculada</h1>
        <p>
          O acesso de <strong>{usuario?.email}</strong> ainda não foi associado a nenhuma
          clínica. Peça ao gestor para incluir você na equipe.
        </p>
        <div className="acoes">
          <button type="button" className="btn-primario" onClick={recarregarClaims}>
            Já me incluíram — verificar
          </button>
          <button type="button" className="btn-texto" onClick={sair}>
            Sair
          </button>
        </div>
      </div>
    </div>
  );
}

/** Papel do usuário não alcança a rota pedida. */
export function SemAcessoPage() {
  return (
    <div className="tela-status">
      <div className="cartao">
        <h1>Sem permissão</h1>
        <p>Seu papel não dá acesso a esta área.</p>
        <Link className="btn-primario" to="/">
          Voltar ao início
        </Link>
      </div>
    </div>
  );
}

export function NaoEncontradaPage() {
  return (
    <div className="tela-status">
      <div className="cartao">
        <h1>Página não encontrada</h1>
        <Link className="btn-primario" to="/">
          Voltar ao início
        </Link>
      </div>
    </div>
  );
}
